// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "content-3R-Dq";
var _3 = "buttons-1ejhL";
var _4 = "closeButton-2LtuK";
export { _1 as "__esModule", _2 as "content", _3 as "buttons", _4 as "closeButton" }
export default { "__esModule": _1, "content": _2, "buttons": _3, "closeButton": _4 }
